import { alphabeticalSorter } from "~/tools/alphabetical-sorter";
import type { Namable } from "~/tools/namable";
import type { Sorter } from "~/tools/sorter";

export const namableAlphabeticalSorter: Sorter<Namable> = (left, right) => alphabeticalSorter(left.name, right.name);
